import types from '../mutation-types'
import profile from '../../api/profile'

const state = {
  profile: {}
}

const mutations = {
  [types.FILL_PROFILE] (state, data) {
    state.profile = data
  }
}

const actions = {
  fillProfile ({commit, dispatch}, data) {
    return profile.get()
      .then((response) => {
        let data = response.data.data
        commit(types.FILL_PROFILE, data)
        dispatch('setBrandingFromProfile', data)
        return response
      })
  },
  updateProfile ({commit}, data) {
    return profile.update(data)
      .then((response) => {
        let data = response.data.data
        commit(types.FILL_PROFILE, data)
        return response
      })
  },
  password (ctx, data) {
    return profile.password(data)
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js